import React, { Component } from 'react'
import { Button, Collapse, FormGroup, Row, Col, CardBody, Card, CardHeader, Nav, NavItem, NavLink } from 'reactstrap'

import './styles.scss'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { locatorsAct } from '../../../../redux/actions'
import { I18n } from 'react-redux-i18n'
import { Formik, Form, Field, FieldArray } from 'formik'

import LocatorValidator from './LocatorValidator'

class PluginLocators extends Component {
  constructor(props) {
    super(props)

    this.state = {
      initialValues: {
        type: 'flight',
        flights: [{ airline: '', locatorFlight: '' }],
        hotels: [{ locatorHotel: '' }],
        insurances: [{ locatorBooking: '', locatorInsurance: '' }],
        errors: {},
        withInsurance: false,
      },
      isOpen: false,
    }

    this.locatorsAct = bindActionCreators(locatorsAct, props.dispatch)
  }

  toggleShowPlugin = () => this.setState((prevState) => ({ isOpen: !prevState.isOpen }))

  handleSubmit = async (values, { setSubmitting, setStatus }) => {
    try {
      const locators = Object.assign({}, values)

      const request = {
        type: locators.type,
        locators: [],
        airlines: [],
        locatorBooking: '',
      }

      for (let row of locators[`${locators.type}s`]) {
        if (locators.type === 'flight') {
          request.locators.push(row.locatorFlight)
          request.airlines.push(row.airline)
        } else if (locators.type === 'insurance') {
          request.locators = row.locatorInsurance
          request.locatorBooking = row.locatorBooking
        } else if (locators.type === 'hotel') {
          request.locators = row.locatorHotel
        }
      }

      if (request.locators.length && request.locators[0]) {
        await this.locatorsAct.sendLocator({ user: this.props.user, locator: request })
        setStatus({ success: I18n.t('plugins.locators.success-sending'), css: 'success' })
      } else {
        setStatus({ success: I18n.t('plugins.locators.error-sending'), css: 'error' })
      }
    } catch (error) {
      setStatus({ success: I18n.t('plugins.locators.error-sending'), css: 'error' })
    } finally {
      setTimeout(() => setStatus({ success: '', css: '' }), 2000)
      setSubmitting(false)
    }
  }

  resetValues = (type) => {
    switch (type) {
      case 'flight':
        return {
          type: type,
          flights: [{ airline: '', locatorFlight: '' }],
          errors: {},
        }
      case 'hotel':
        return {
          type: type,
          hotels: [{ locatorHotel: '' }],
          errors: {},
        }
      case 'insurance':
        return {
          type: type,
          insurances: [{ locatorBooking: '', locatorInsurance: '' }],
          errors: {},
        }
      default:
        return {}
    }
  }

  getFieldsByType = (values, status) => {
    switch (values.type) {
      case 'hotel':
        return (
          <>
            {/*   <Row>
                            <Col xs={8}/>
                            <Col xs={4}>
                                <FormGroup check>
                                    <Label check>
                                        <Field type="checkbox" name={"withInsurance"}/>{"Con seguro"}
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>*/}
            <Row noGutters>
              <Col className={'ml-1'}>{I18n.t('plugins.locators.locator')}</Col>
            </Row>
            <FieldArray
              name={`${values.type}s`}
              render={() => (
                <div>
                  {values[`${values.type}s`].map((r, i) =>
                    i > 0 ? null : (
                      <div key={i} className='mb-1'>
                        <Row noGutters>
                          <Col className='mr-1'>
                            <Field name={`${values.type}s.${i}.locatorHotel`} className='form-control' type='text' />
                          </Col>
                        </Row>
                      </div>
                    )
                  )}
                  <Row>
                    <Col className='mb-0 text-center' xs={12}>
                      <div className={`form-sending ${status ? status.css : ''}`}>{status ? status.success : ''}</div>
                    </Col>
                  </Row>
                </div>
              )}
            />
          </>
        )
      case 'flight':
        return (
          <>
            {/* <Row>
                            <Col xs={7}/>
                            <Col xs={5}>
                                <FormGroup check>
                                    <Label check>
                                        <Field type="checkbox" name={"withInsurance"}/>{"Incluir seguro"}
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>*/}
            <Row noGutters>
              <Col className={'ml-1'}>{I18n.t('plugins.locators.locator')}</Col>
              <Col className={'ml-2'}>{I18n.t('plugins.locators.airline')}</Col>
              {values[`${values.type}s`].length > 1 && <Col xs={1} />}
            </Row>
            <FieldArray
              name={`${values.type}s`}
              render={(arrayHelpers) => (
                <div>
                  {values[`${values.type}s`].map((r, i) => (
                    <div key={i} className='mb-1'>
                      <Row noGutters>
                        <Col className='mr-1'>
                          <Field name={`${values.type}s.${i}.locatorFlight`} className='form-control' type='text' />
                        </Col>

                        <Col className='ml-1'>
                          <Field name={`${values.type}s.${i}.airline`} className='form-control' type='text' />
                        </Col>

                        {values[`${values.type}s`].length > 1 && (
                          <Col xs={1} className='text-center'>
                            <span style={{ cursor: 'pointer' }} onClick={() => arrayHelpers.remove(i)}>
                              <i className='fa fa-times' />
                            </span>
                          </Col>
                        )}
                      </Row>
                    </div>
                  ))}
                  <Row>
                    <Col className='mb-0 text-center' xs={12}>
                      <div className={`form-sending ${status ? status.css : ''}`}>{status ? status.success : ''}</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className='my-3 text-center'>
                      <Button color='default' onClick={() => arrayHelpers.push({ airline: '', locatorFlight: '' })}>
                        {I18n.t('dashboard_add-locator')}
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
            />
          </>
        )
      case 'insurance':
        return (
          <>
            <Row noGutters>
              <Col className={'ml-1'}>{I18n.t('plugins.locators.locator-insurance')}</Col>
              <Col className={'ml-2'}>{I18n.t('plugins.locators.locator-booking')}</Col>
            </Row>
            <FieldArray
              name={`${values.type}s`}
              render={() => (
                <div>
                  {values[`${values.type}s`].map((r, i) => (
                    <div key={i} className='mb-1'>
                      <Row noGutters>
                        <Col className='mr-1'>
                          <Field name={`${values.type}s.${i}.locatorInsurance`} className='form-control' type='text' />
                        </Col>
                        <Col className='ml-1'>
                          <Field name={`${values.type}s.${i}.locatorBooking`} className='form-control' type='text' />
                        </Col>
                      </Row>
                      <Row>
                        <Col className='mb-3 text-center' xs={12}>
                          <div className={`form-sending ${status ? status.css : ''}`}>{status ? status.success : ''}</div>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              )}
            />
          </>
        )
      default:
    }
  }

  render() {
    return (
      <div className='plugin-payment-card' hidden={this.props.company.type === 'OP'}>
        <div className='title-container'>
          <div className='title'>
            <i className={'fa fa-globe nav-icon-resources'} />
            {I18n.t('plugins.locators.title')}
          </div>
          <div className='action-buttons-container'>
            <i className={`fa fa-chevron-${this.state.isOpen ? 'up' : 'down'}`} onClick={this.toggleShowPlugin} />
          </div>
        </div>
        <Collapse isOpen={this.state.isOpen}>
          <div className='separator' />
          <Formik initialValues={this.state.initialValues} validate={LocatorValidator} onSubmit={this.handleSubmit}>
            {({ isSubmitting, setFieldValue, values, resetForm, status }) => {
              return (
                <Form>
                  <Card className='mt-3 content-container'>
                    <CardHeader className='bg-white'>
                      <Nav pills>
                        <NavItem>
                          <NavLink className={values.type === 'flight' ? 'active' : ''} onClick={() => setFieldValue('type', 'flight')}>
                            {I18n.t('dashboard_flight')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink className={values.type === 'hotel' ? 'active' : ''} onClick={() => setFieldValue('type', 'hotel')}>
                            {I18n.t('dashboard_hotel')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink className={values.type === 'insurance' ? 'active' : ''} onClick={() => setFieldValue('type', 'insurance')}>
                            {I18n.t('plugins.locators.insurance')}
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </CardHeader>
                    <CardBody>
                      <FormGroup>{this.getFieldsByType(values, status)}</FormGroup>
                      <Row>
                        {values.type === 'flight' && values[`${values.type}s`].length && (
                          <Col>
                            <Button
                              className='font-weight-normal'
                              color='default'
                              onClick={(e) => {
                                e.preventDefault()
                                resetForm(this.resetValues(values.type))
                              }}
                            >
                              &times;{I18n.t('dashboard_restore')}
                            </Button>
                          </Col>
                        )}
                        <Col className='text-right'>
                          <Button type='submit' color='primary' disabled={isSubmitting}>
                            {I18n.t('dashboard_send-locator')}
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Form>
              )
            }}
          </Formik>
        </Collapse>
      </div>
    )
  }
}

export default connect((state) => ({ company: state.companies }))(PluginLocators)
